<template>
  <div class="pageStyle">
    <div class="top-bg"></div>
    <div class="top-title">
      <div>
        <span>结算资料</span>
        <span>管理您的结算资料信息</span>
      </div>
      <div>
        <img
          src="https://static.xchengtech.cn/5927dc560b8048dc87ede7a09c175670.png"
          alt=""
        />
      </div>
    </div>
    <!-- <div class="header">管理您的结算账户</div> -->
    <div class="content">
      <div
        class="item"
        v-for="(item, index) in dataList"
        :key="index"
        @click="toEdit(item.id)"
      >
        <div class="name" v-show="item.name">
          <div>
            <span>姓名</span>
            <span> {{ item.name }}</span>
          </div>
          <div>
            <!-- 删除按钮图标 -->
            <van-icon
              class="closeIcon"
              name="clear"
              size="18px"
              @click.stop="toDelete(item.id)"
            />
          </div>
        </div>
        <div class="phone" v-show="item.phone">
          <span>手机号</span>
          <span> {{ item.phone }}</span>
        </div>
        <div class="bankCard" v-show="item.bankNum">
          <span>银行卡号</span>
          <span>{{ item.bankNum }}</span>
        </div>
        <div class="cardBg">
          <span>
            {{ index + 1 }}
          </span>
        </div>
      </div>
      <div class="addCard" @click="toAdd">
        <div>
          <van-icon name="plus" size="30px" color="#B6C3D2" />
        </div>
        <div>点击新增账户</div>
      </div>
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>
import { xcChannelPayInfo } from "@/api/accountCenter";
import { delXcChannelPayInfo } from "@/api/accountCenter";
import { getCurrentChannelInfo } from "@/api/login.js";
import { Icon, Dialog, Toast, Notify } from "vant";
export default {
  components: {
    [Icon.name]: Icon,
  },
  watch: {
    dataList: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue.length > 0) {
          console.log("newValue", newValue);
          this.$nextTick(() => {
            let i = 0;
            while (i < newValue.length) {
              this.getColor("dataList" + i);
              i++;
            }
          });
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      dataList: [],
      channelInfo: {},
    };
  },

  mounted() {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: "加载中",
    });
    // 获取渠道用户信息
    getCurrentChannelInfo()
      .then((res) => {
        console.log("res", res);
        this.channelInfo = res;
        this.getData();
      })
      .catch((err) => {
        console.log("err", err);
        Toast.clear();
      });
  },

  methods: {
    toDelete(id) {
      console.log("id", id);
      Dialog.confirm({
        title: "提示",
        // message: "<div>确认删除该账户吗？</div><div>删除后需及时告知客服</div>",
        message: "<div>确认删除该账户吗？</div>",
      })
        .then(() => {
          Toast.loading({
            duration: 0,
            message: "删除中...",
            forbidClick: true,
            overlay: true,
          });

          delXcChannelPayInfo(id).then((res) => {
            Notify({ type: "success", message: "删除成功" });
            this.getData();
          });

          // on confirm
        })
        .catch(() => {
          // on cancel
        });
    },
    toEdit(id) {
      Dialog.confirm({
        title: "提示",
        message: "是否编辑该结算账户？",
      })
        .then(() => {
          this.$router.push({
            name: "authentication",
            query: {
              id: id,
            },
          });
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
    },
    toAdd() {
      this.$router.push({
        name: "authentication",
      });
    },
    getData() {
      if (this.channelInfo.id) {
        xcChannelPayInfo(this.channelInfo.id)
          .then((res) => {
            Toast.clear();
            this.dataList = res;
          })
          .catch((err) => {
            console.log("err", err);
            Toast.clear();
          });
      }
    },
  },
};
</script>
<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/view/accountCenter/index.vue